import { string } from "prop-types";

const AmsterdamZuid = ({ className }) => (
  <path
    d="M591.219 540.83H474.359V501.188H448.137V505.978H423.707V521.009H364L383.944 501.147H437.838L451.902 488.8H469.682L447.341 470.218V465.56H439.048L430.756 457.83V425.621H444.024V380.199H454.804V367.869H472.957V377.308H480.097L526.536 357.487H539.456L550.585 350.055L577.95 369.875H617.755L648.438 449.985L625.218 464.024L620.243 481.367L599.511 490.452V506.969L591.219 540.83Z"
    fill="url(#paint0_linear_14735_232327)"
    fillOpacity="0.25"
    stroke="#4D4D4D"
    strokeWidth="2"
    strokeMiterlimit="10"
    strokeDasharray="4 4"
    className={className}
  />
);

AmsterdamZuid.propTypes = {
  className: string,
};

export default AmsterdamZuid;
